import React from "react";

function SathaOrdersActions() {
  return (
    <nav className="uk-position-relative" aria-label="Breadcrumb">
      <ul className="uk-breadcrumb">
        <li>
          <span>الصيانة</span>
        </li>
        <li>
          <span aria-current="page">طلبات السطحة</span>
        </li>
      </ul>
    </nav>
  );
}

export default SathaOrdersActions;
